import { MapUnsupportedTypesAlert } from 'ui-components'

function MapFileAlert(props) {
  const { error } = props
  if (!error) return null
  return <MapUnsupportedTypesAlert />
}

export { MapFileAlert }
